'use strict';

var $ = require('jquery');

var sUniformStyled = 'uniformstyled';

require('jquery.uniform');

module.exports = function () {
    $(['input:checkbox', 'input:radio', 'select']).each(function () {
        $(this + ':not(.' + sUniformStyled + ')')
            .not('.no-uniform')
            .not(() => {
                return $(this).parents('.ot-tgl').length;
            })
            .addClass(sUniformStyled)
            .uniform();
        if ($(this).hasClass('loading-element')) {
            $(this).removeClass('loading-element');
        }
    });

    // workaround to prevent Firefox bug (turning arrow)
    $(window).on('beforeunload', function () {
        $('select.jsQtyUpdate').closest('.selector').addClass('unload');
    });
};
